<template>
    <component :is="tag" style="display: inherit" @mouseover="triggerTooltip(true)" @mouseleave="triggerTooltip(false)" @click="$emit('click')">
        <slot/>

		<!-- Client-only required due to Teleport -->
		<client-only>
			<Teleport to=".tooltip-portal">
				<transition name="scale-transition">
					<div v-if="isActive" ref="popup" :style="popupStyle">
						<div class="tooltip whitespace-pre-line">{{ text }}</div>
					</div>
				</transition>
			</Teleport>
		</client-only>
    </component>
</template>

<script>
import RelativePopupElement from "../../mixins/RelativePopupElement";

export default {
    name: 'Tooltip',

    mixins: [RelativePopupElement],

	emits: ['click'],

    props: {

        // The text to display within the tooltip
        text: {
            type: String,
            default: null
        },

        // Whether to show the tooltip via click on touch devices since no hover event exists on touch devices
        withTouch: {
            type: Boolean,
            default: false
        },

        minWidth: {
            type: [String, Number],
            default: 120
        },

        maxWidth: {
            type: [String, Number],
            default: 240
        },

		tag: {
			type: String,
			default: 'div'
		}
    },

    methods: {
        triggerTooltip(show) {
            if (this.withTouch || this.$device.isDesktop) {
                this.isActive = show;
            } else {
                this.isActive = false;
            }
        }
    }
}
</script>

<style>
/*********************
  Inputs
**********************/
.tooltip {
  line-height: 1.2;
  background-color: #465050;
  color: #ffffff;
  text-align: center;
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 13.5px;
}
</style>